export const REPORTS = '/report';
export const GET_REPORTS = '/report/';
export const DELETE_REPORTS = '/report';
export const ADD_REPORTS = '/report/';
export const UPDATE_REPORTS = '/report';
